import { INewsState } from '~/store/news/INewsState'

export default (): INewsState => ({
  news: [],
  lastLoad: new Date(0)
})
